import listings from './listings'

export default listings
